// extracted by mini-css-extract-plugin
module.exports = {"selected":"_f4dad4d","changeText":"_8a8e8b7","withBorder":"_b9462e5","withoutBorder":"_0913c1f"};